module.exports = __webpack_public_path__ + "img/pic_hands.ec8eed9d.jpg";